import isCordova from "./isCordova";

export default () => {
  const { navigator } = window;

  if (isCordova) {
    navigator.splashscreen.hide();
  }
};
